export default __webpack_public_path__ + "static/media/Thank-you.004e0eac.png";